import { render, staticRenderFns } from "./enumType.vue?vue&type=template&id=2231be9a&scoped=true"
import script from "./enumType.vue?vue&type=script&lang=js"
export * from "./enumType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231be9a",
  null
  
)

export default component.exports